module.exports = __webpack_public_path__ + "img/legendary.34833eab.png";